import React, { useState } from "react";
import { Pencil, Check, X } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

/** Click-to-edit "erledigte UE" value for a client section / Onboarding / Offboarding row. */
export default function EditableUeCell({ clientId, kind, sectionId, ueCompleted, ueTarget, onSaved, readOnly, testId }) {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(ueCompleted || 0);
  const [saving, setSaving] = useState(false);

  const startEdit = () => { setValue(ueCompleted || 0); setEditing(true); };

  const save = async () => {
    const v = parseFloat(value);
    if (Number.isNaN(v) || v < 0) { toast.error("Ungültiger Wert"); return; }
    if (ueTarget && v > ueTarget) { toast.error(`Erledigte UE darf die Ziel-UE (${ueTarget}) nicht übersteigen`); return; }
    setSaving(true);
    try {
      await api.patch(`/clients/${clientId}/ue-completed`, { kind, section_id: sectionId, ue_completed: v });
      toast.success("Erledigte UE aktualisiert");
      setEditing(false);
      onSaved?.();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally { setSaving(false); }
  };

  if (editing) {
    return (
      <span className="inline-flex items-center gap-1">
        <input
          type="number" min="0" step="0.5" autoFocus
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") save(); if (e.key === "Escape") setEditing(false); }}
          className="w-16 font-mono text-sm border border-[#00CCC9] px-1 py-0.5 focus:outline-none"
          data-testid={`${testId}-input`}
        />
        <button onClick={save} disabled={saving} data-testid={`${testId}-save`} className="text-emerald-600 hover:text-emerald-700 disabled:opacity-50">
          <Check size={14} strokeWidth={2} />
        </button>
        <button onClick={() => setEditing(false)} data-testid={`${testId}-cancel`} className="text-slate-400 hover:text-slate-600">
          <X size={14} strokeWidth={2} />
        </button>
      </span>
    );
  }

  return (
    <span
      onClick={readOnly ? undefined : startEdit}
      data-testid={testId}
      title={readOnly ? undefined : "Klicken zum Bearbeiten"}
      className={`font-mono text-sm text-slate-900 inline-flex items-center gap-1 ${readOnly ? "" : "hover:text-[#0a788c] cursor-pointer group"}`}
    >
      <span className={readOnly ? "" : "underline decoration-dotted decoration-slate-300 underline-offset-2 group-hover:decoration-[#0a788c]"}>{ueCompleted || 0}</span>
      {!readOnly && <Pencil size={10} strokeWidth={1.5} className="opacity-0 group-hover:opacity-60 transition-opacity" />}
    </span>
  );
}
